<template>
  <div>
    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      class="p-no-borders"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:[`item.name`]="{ item }">
        <span class="font-weight-medium">{{ item.name }}</span>
      </template>
      <template v-slot:[`item.income`]="{ item }">
        <p-currency :value="item.income"></p-currency>
      </template>
      <template v-slot:[`item.expenses`]="{ item }">
        <p-currency :value="item.expenses"></p-currency>
      </template>
      <template v-slot:[`item.total`]="{ item }">
        <p-currency :value="item.total"></p-currency>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'

import PCurrency from '@/components/PCurrency'


export default {
  components: {
    PCurrency
  },


  computed: {
    ...mapGetters('budget', ['budgetTotal']),
    ...mapGetters('season', ['currentSeason']),
    ...mapGetters('project', ['currentProject', 'currentProjectId']),

    tableHeaders () {
      return [
        { text: '', value: 'name', sortable: false },
        { text: this.$t('budget.income'), value: 'income', align: 'end', sortable: false },
        { text: this.$t('budget.expenses'), value: 'expenses', align: 'end', sortable: false },
        { text: this.$t('budget.total'), value: 'total', align: 'end', sortable: false }
      ]
    },

    tableItems () {
      const budgetTotal = this.budgetTotal(this.currentProjectId)

      return [
        {
          name: this.$t('budget.projectTotal', { project: this.currentProject.title }),
          income: budgetTotal.projectIncome,
          expenses: budgetTotal.projectTotalExpenses,
          total: budgetTotal.projectTotal
        },
        {
          name: this.$t('budget.seasonTotal', { season: this.currentSeason.name }),
          income: budgetTotal.seasonIncome,
          expenses: budgetTotal.seasonTotalExpenses,
          total: budgetTotal.seasonTotal
        },
        {
          name: this.$t('budget.budgetTotal', { season: this.currentSeason.name }),
          income: budgetTotal.budgetIncome,
          expenses: budgetTotal.budgetExpenses,
          total: budgetTotal.budgetTotal
        }
      ]
    }
  }
}
</script>
